// ContactPage.jsx
import { useState, useMemo, useEffect } from 'react';
import Navbar from '../pages/Navbar';
import Footer from '../components/Footer';
import Chatbot from '../components/Chatbot';
import '../styles/ContactPage.css';
import { apiUrl } from '../config';

export default function ContactPage() {
  const bust = useMemo(() => Date.now(), []);

  const [i, setI] = useState(0);
  const heroCandidates = [
    `https://source.unsplash.com/1200x800/?feedback,health&sig=${bust}`,
    `https://picsum.photos/seed/${bust}/1200/800`,
    `https://placehold.co/1200x800?text=We+Value+Your+Feedback`,
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');
    try {
      const res = await fetch(apiUrl('/api/feedback'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      await res.json().catch(() => ({}));
     if (res.ok) {
  setStatus('Thank you for your feedback!');
  setFormData({ name: '', email: '', message: '' });
} else {
  setStatus('Failed to send. Try again later.');
}
    } catch (err) {
      setStatus('Error occurred.');
    }
  };

  return (
    <>
      <Navbar />
      <main className="about">
        <div className="about-grid">
          <section className="about-left fade-in">
            <img
              src={heroCandidates[i]}
              alt="Feedback banner"
              onError={() => setI((n) => Math.min(n + 1, heroCandidates.length - 1))}
            />
          </section>

          <section className="about-right">
            <div className="card motto-card">
              <h2>Give Feedback</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <textarea
                  name="message"
                  placeholder="Your Feedback"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
                <button type="submit">Submit</button>
                {status && <p>{status}</p>}
              </form>
            </div>
          </section>
        </div>
      </main>
      <Footer />
      <Chatbot />
    </>
  );
}
